<div class="modal-content bary-add-or-update-address">
  <div class="modal-header">
    <p class="step" jhiTranslate="modals.addOrUpdateAddress.step" [translateValues]="{ stepNumber: step }"></p>
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    <p class="modal-title h4">{{ 'modals.addOrUpdateAddress.title.' + addOrUpdate | translate }}</p>
  </div>

  <form *ngIf="step === 1">
    <div class="modal-body">
      <jhi-bary-options-selector
        [control]="formGroup.controls.addressType"
        [options]="_addressTypeSelector"
        [title]="'modals.addOrUpdateAddress.step1.addressType.title' | translate"
        [id]="'addressType'"
      ></jhi-bary-options-selector>
      <span class="font-weight-bold" jhiTranslate="modals.addOrUpdateAddress.step1.infoContact.title"></span>
      <jhi-bary-address-form [addressForm]="formGroup.controls.address" [options]="options"></jhi-bary-address-form>
      <div class="my-3">
        <div class="alert alert-warning" role="alert">
          <jhi-bary-icon icon="info-circle" [faDirective]="FAS" class="mr-1"></jhi-bary-icon>
          <span class="warning" jhiTranslate="LOADING_CONSTRAINT.MESSAGE.WARNING"></span>
        </div>
        <jhi-loading-constraint [options]="{ isPickup: isPickup() }" [control]="formGroup.controls.loadingConstraint"> </jhi-loading-constraint>
        <jhi-access-constraint [options]="{ isPickup: isPickup() }" [control]="formGroup.controls.accessConstraint"></jhi-access-constraint>
        <p class="legal-notice">{{ 'modals.addOrUpdateAddress.step2.legalNotice' | translate }}</p>
      </div>
    </div>
    <!--Footer-->
    <div class="modal-footer justify-content-end">
      <jhi-bary-button
        [outline]="true"
        color="primary"
        class="mr-2"
        [label]="'modals.addOrUpdateAddress.step1.buttons.first' | translate"
        (clickEvent)="handleClick({ cancel: true })"
      ></jhi-bary-button>
      <jhi-bary-button
        data-id-cypress="next-step-1"
        (clickEvent)="handleClick({ next: true, value: 2 })"
        [label]="'modals.addOrUpdateAddress.step1.buttons.second' | translate"
        color="primary"
      ></jhi-bary-button>
    </div>
  </form>

  <form *ngIf="step === 2">
    <div class="modal-body mb-5">
      <span class="font-weight-bold" jhiTranslate="modals.addOrUpdateAddress.step2.timeslot.title"></span>
      <span class="font-weight-bold my-5" jhiTranslate="modals.addOrUpdateAddress.step1.infoContact.title"></span>
      <div class="form-row form-row-list">
        <jhi-bary-input-select
          class="col-md-2"
          [control]="formGroup.controls.contact.controls.civility"
          [options]="_civilitiesOptions"
          [id]="'contactCivility'"
        ></jhi-bary-input-select>
        <jhi-bary-input-text
          class="col-md-5"
          data-id-cypress="contact-last-name"
          [control]="formGroup.controls.contact.controls.lastName"
          [label]="'modals.addOrUpdateAddress.step1.infoContact.input.contactLastName' | translate"
          [id]="'contactLastName'"
        ></jhi-bary-input-text>
        <jhi-bary-input-text
          class="col-md-5"
          data-id-cypress="contact-first-name"
          [control]="formGroup.controls.contact.controls.firstName"
          [label]="'modals.addOrUpdateAddress.step1.infoContact.input.contactFirstName' | translate"
          [id]="'contactFirstName'"
        ></jhi-bary-input-text>
      </div>
      <div class="form-row">
        <jhi-bary-input-email
          class="col-md-8"
          data-id-cypress="contact-email"
          [control]="formGroup.controls.contact.controls.mail"
          [label]="'modals.addOrUpdateAddress.step1.infoContact.input.contactMail' | translate"
          [id]="'contactMail'"
        ></jhi-bary-input-email>
        <jhi-bary-input-phone
          class="col-md-4"
          data-id-cypress="contact-phone"
          [control]="formGroup.controls.contact.controls.phone"
          [label]="'modals.addOrUpdateAddress.step1.infoContact.input.contactPhone' | translate"
          [id]="'contactPhone'"
        ></jhi-bary-input-phone>
      </div>
    </div>
    <!--Footer-->
    <div class="modal-footer justify-content-end">
      <jhi-bary-button
        [outline]="true"
        color="primary"
        [label]="'modals.addOrUpdateAddress.step2.buttons.first' | translate"
        (clickEvent)="handleClick({ back: true, value: 1 })"
        class="mr-2"
      ></jhi-bary-button>
      <jhi-bary-button
        data-id-cypress="next-step-2"
        (clickEvent)="handleClick({ next: true, value: 3 })"
        [label]="'modals.addOrUpdateAddress.step1.buttons.second' | translate"
        color="primary"
      ></jhi-bary-button>
    </div>
  </form>

  <form *ngIf="step === 3">
    <div class="modal-body">
      <jhi-bary-input-text
        data-id-cypress="alias"
        [control]="formGroup.controls.alias"
        [label]="'modals.addOrUpdateAddress.step3.alias' | translate"
        [id]="'alias'"
      ></jhi-bary-input-text>
    </div>
    <!--Footer-->
    <div class="modal-footer justify-content-end">
      <jhi-bary-button
        [outline]="true"
        class="mr-2"
        color="primary"
        [label]="'modals.addOrUpdateAddress.step3.buttons.first' | translate"
        (clickEvent)="handleClick({ back: true, value: 2 })"
      ></jhi-bary-button>
      <jhi-bary-button
        data-id-cypress="next-step-3"
        (clickEvent)="handleSubmit({ submit: true, value: model })"
        [label]="'modals.addOrUpdateAddress.step3.buttons.second' | translate"
        color="primary"
      ></jhi-bary-button>
    </div>
  </form>
</div>
